import CustomItem from '../screens/CustomItem';
import ItemDetailsPage from '../screens/ItemDetailsPage';
import {ItemDetailsScreen} from './types';
import ItemLocationPage from '../screens/ItemLocationPage';
import ItemReplacement from '../screens/ItemReplacement';
import ItemScanner from '../screens/ItemScanner';
import ItemUpdate from '../screens/ItemUpdate';
import NSCItemScanner from '../screens/NSCItemScanner';
import React from 'react';
import ReplacementItemDetailPage from '../screens/ReplacementItemDetailPage';
import SubstituteItemDetailPage from '../screens/SubstituteItemDetailPage';
import {createNativeStackNavigator} from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

const MainNavigator: React.FC = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen
        name={ItemDetailsScreen.ItemDetailsPage}
        component={ItemDetailsPage}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.ItemReplacement}
        component={ItemReplacement}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.ItemScanner}
        component={ItemScanner}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.NSCItemScanner}
        component={NSCItemScanner}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.ItemUpdate}
        component={ItemUpdate}
        options={{
          gestureEnabled: false,
        }}
      />

      <Stack.Screen
        name={ItemDetailsScreen.CustomItem}
        component={CustomItem}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.ItemLocationPage}
        component={ItemLocationPage}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.SubstituteItemDetailPage}
        component={SubstituteItemDetailPage}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.ReplacementItemDetailsPage}
        component={ReplacementItemDetailPage}
        options={{
          gestureEnabled: false,
        }}
      />
    </Stack.Navigator>
  );
};

export default MainNavigator;
